module.exports = __webpack_public_path__ + "static/media/aph_letters.de68a1ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aph_letters.png
// module id = 1448
// module chunks = 0